module.exports = __webpack_public_path__ + "static/media/map-marker.30e950b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map-marker.svg
// module id = 251
// module chunks = 1